import React from 'react';
import Banner from '@cpg-its/ads.containers.banner';
import { ContentSpacer } from '../layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';

interface MappedMessageProps {
	message: string;
	supplement?: string | JSX.Element;
	useWarning?: boolean;
}
export function MappedMessage(props: MappedMessageProps) {
	const { message, supplement, useWarning } = props;

	const Supplement = () => {
		if (!supplement) return null;

		if (typeof supplement === 'string') {
			return (
				<WysiwygWithReactLink content={supplement} />
			);
		}

		return supplement;
	};

	return (
		<>
			<ContentSpacer>
				<Banner banner={{
					type: useWarning ? 'warning' : 'success',
					label: <WysiwygWithReactLink className='input-label' content={message || 'Success!'} />,
					description: <Supplement />,
				}} />
			</ContentSpacer>

		</>

	);
}

MappedMessage.defaultProps = {
	supplement: null,
	useWarning: false,
};